module.exports = __webpack_public_path__ + "media/images/icons/santa1-cdf43d6e676230107422792d23386f95.png";